/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="company">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          :scroll="{ x: 1200, y: $store.getters.listTableHeight }"
          :pagination="pager"
          rowKey="_id"
          @change="change">
        <span slot="action" slot-scope="text, record">
          <a @click="modify(record)" v-has:modifyCompany>修改</a>
          <a-divider type="vertical" />
          <a @click="showRecharg(record._id)">充值</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              更多<a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <router-link :to="`/company/mpmenu/${record._id}`">配置公众号菜单</router-link>
              </a-menu-item>
              <a-menu-item>
                <a @click="editCabinetTmp(record._id)">编辑格子模板</a>
              </a-menu-item>
              <a-menu-item :style="{display: record.type === '1' ? 'none' : 'block'}">
                <a
                  @click="showWithdrawal(record._id)"
                  :disabled="record.type === '1'"
                  :class="{'disabled': record.type === '1'}"
                  >提现申请</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <edit-cabinet-tmp ref="cabinetAdd" />
    <withdrawalModel ref="withdrawalModel" />
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex';
import editCabinetTmp from './editCabinetTmp.vue';
import withdrawalModel from './withdrawal.vue';

const columns = [
  {
    title: '公司id',
    dataIndex: 'serial',
    key: 'serial',
  },
  {
    title: '公司名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '地址',
    dataIndex: 'address',
    key: 'address',
    ellipsis: true,
  },
  {
    title: '付费方式',
    dataIndex: 'provideType',
    key: 'provideType',
  },
  {
    title: '余额',
    dataIndex: 'account',
    key: 'account',
  },
  {
    title: '创建时间',
    dataIndex: 'ctime',
    key: 'ctime',
  },
  {
    title: '备注',
    key: 'remark',
    dataIndex: 'remark',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 170,
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  components: { editCabinetTmp, withdrawalModel },
  data() {
    return {
      columns,
      search: {
        pageSize: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapState({
      list: (state) => state.company.list,
      pager: (state) => state.company.pager,
      listloading: (state) => state['@@loading'].effects.getCompanyList,
    }),
  },
  methods: {
    ...mapActions(['getCompanyList']),
    getList() {
      this.getCompanyList(this.search);
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    modify({ _id }) {
      this.$router.push(`/company/modify/${_id}`);
    },
    showRecharg(id) {
      this.$router.push(`/company/recharge/${id}`);
    },
    editCabinetTmp(id) {
      this.$refs.cabinetAdd.show(id);
    },
    showWithdrawal(id) {
      this.$refs.withdrawalModel.show(id);
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.company {
}
.disabled{
    display: none;
  }
</style>
